<template>
	<div>
		<div class="ft20 cl-main ftw600">店铺管理</div>
		<div class="mt20">
			<a-button type="primary" icon="plus" @click="add()">添加店铺</a-button>
		</div>
		<div >
			<div class="form-search-box mt20">
				<a-form layout="inline">
					<a-form-item  label="所属区域">
						<a-cascader
							:options="options"
							:default-value="search.region"
							change-on-select
							@change="onChangeRegion"
							placeholder="请选择区域"
						/>
					</a-form-item>
					<a-form-item label="关键字">
						<a-input v-model="search.keywords" placeholder="请输入店铺名称"></a-input>
					</a-form-item>
					<a-form-item>
						<a-button @click="handelSearch" type="primary">查询</a-button>
					</a-form-item>
				</a-form>
			</div>
		</div>

		<div class="mt20">
			<div class="wxb-table-white">
				<a-table rowKey="shop_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
				:loading="loading">
                    <div slot="logo_image" slot-scope="record">
                        <img width="100" height="100" :src="record.logo" />
					</div>
					<div slot="shop_address" slot-scope="record">
						<p v-if="record.province">
							{{record.province.name}}{{record.city.name}}{{record.area.name}}{{record.address}}
						</p>
					</div>
					
					<div slot="stats" slot-scope="record">
						<span class="fs12 br5" :class="record.state.class">{{record.state.text}}</span>
					</div>

					<template slot="action" slot-scope="text,record">
						<div class="center operate">
							<a class="menu-act fs12 bd-blue" href="javascript:;" @click="edit(record)">
								<span>修改</span>
							</a>
							<a class="menu-act fs12 bd-red" href="javascript:;" @click="del(record)">
								<span>删除</span>
							</a>
						</div>
					</template>
				</a-table>
			</div>
			<div v-if="editShow">
				<edit :visible="editShow" :shopId="shopId" @cancel="cancel" @ok="ok"></edit>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		listMixin
	} from '@/common/mixin/list.js';
	import region from '@/assets/js/region.js';
	export default {
		mixins: [listMixin],
		data() {
			return {
				loading: false,
				editShow: false,
				shopId: 0,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					keywords: '',
					region: [],
				},
				options: [],
				columns: [
					{title: 'ID',dataIndex: 'shop_id',align: 'center',ellipsis: true},
					{title: '店铺名称',dataIndex: 'name',align: 'left',ellipsis: true},
                    {title: '店铺logo', key: 'logo_image', width:150, align: 'center',  scopedSlots: {customRender: 'logo_image'}},
					{title: '营业时间', dataIndex: 'business_hours', width:150, align: 'left', ellipsis: true},
					{title: '联系电话', dataIndex: 'tel', width:150, align: 'center', ellipsis: true},
					{title: '地址', key: 'shop_address', align: 'center',  scopedSlots: {customRender: 'shop_address'}},
					{title: '状态', key: 'stats', align: 'center', width:80, scopedSlots: {customRender: 'stats'}},
					{title: '操作',key: 'action',align: 'center', width:200, scopedSlots: {customRender: 'action'}},
				],
				datas: [],
			}
		},
		created() {
			this.options = region.map;
            this.getLists();
		},
		methods: {
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('platform/shop/getShopList',{
					keywords: this.search.keywords,
					region: this.search.region,
					limit:this.pagination.pageSize,
					page:this.pagination.current,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
				}).catch(res=>{
					console.log(res);
				}).finally(()=>{
					this.loading=false;
				})
				
			},
			onChangeRegion(value) {
				console.log(value);
				this.search.region = value;
			},
			handelSearch(){
				this.getLists();
			},

			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			//添加店铺
			add(){
				this.$router.push('/setting/shop/edit')
			},
			edit(record){
				this.$router.push('/setting/shop/edit?shop_id='+ record.shop_id)
			},
			ok(){
				this.editShow = false;
				this.getLists();
			},
			del(record){
				this.$confirm({
					title:'您确定要删除当前店铺信息吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('platform/shop/delShop',{
								shop_id: record.shop_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
		}
	}
</script>

<style>
p{margin:0;}
.operate p{ line-height: 24px;}
</style>
